module.exports = __webpack_public_path__ + "a71b9df62fdba264a6128d9e9c3a79c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/iconfont.svg
// module id = 354
// module chunks = 0 204 209